import React from 'react'
import Noun from '../../components/Noun'

import content from './_content.yaml'
import meta from './_meta.yaml'

export default () => (
  <Noun
    content={content}
    meta={meta}
  />
)
